import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getCaseDocuments,
  createCaseDoc,
  updateCaseDoc,
  deleteCaseDoc,
} from "../../../api/cd_caseDocs_api";

export const fetchCaseDocuments = createAsyncThunk(
  "caseDocuments/fetchCaseDocuments",
  async (caseID, { rejectWithValue }) => {
    try {
      const response = await getCaseDocuments(caseID);
      if (!response.success) {
        return rejectWithValue(response.message || "Failed to fetch documents");
      }
      return response.documents || [];
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Network error");
    }
  },
);

export const createCaseDocument = createAsyncThunk(
  "caseDocuments/createCaseDocument",
  async ({ caseID, formData }, { rejectWithValue }) => {
    try {
      const response = await createCaseDoc(caseID, formData);
      return response.data; // should include the created document
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to create document",
      );
    }
  },
);

export const updateCaseDocument = createAsyncThunk(
  "caseDocuments/updateCaseDocument",
  async ({ caseDocId, formData }, { rejectWithValue }) => {
    try {
      const response = await updateCaseDoc(caseDocId, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to update document",
      );
    }
  },
);

export const deleteCaseDocument = createAsyncThunk(
  "caseDocuments/deleteCaseDocument",
  async (caseDocId, { rejectWithValue }) => {
    try {
      await deleteCaseDoc(caseDocId);
      return caseDocId;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to delete document",
      );
    }
  },
);
